import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';
import type { Assignment, PaginatedResponse } from '@/types/worker';

interface AssignmentParams {
    status?: string;
    limit?: number;
    offset?: number;
}

export const useAssignments = (params: AssignmentParams = {}) => {
    const queryParams: Record<string, string> = {};
    if (params.status) queryParams.status = params.status;
    if (params.limit) queryParams.limit = String(params.limit);
    if (params.offset) queryParams.offset = String(params.offset);

    return useQuery({
        queryKey: WORKER_KEYS.assignments(queryParams),
        queryFn: async (): Promise<PaginatedResponse<Assignment>> => {
            const { data } = await api.get(API_ROUTES.workerAssignments, { params: queryParams });
            return data;
        },
        staleTime: 30 * 1000,
    });
};
